import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { useSellarUser } from "../../../useSellarUser.shared";

export const useLegalEntityId = () => {
  const sellarUser = useSellarUser();
  const { business } = useSellarCurrentBusiness();

  const designatedLegalEntityId =
    sellarUser.user?.type === "admin"
      ? undefined
      : sellarUser.user?.legalEntityAdminList[0]?.legalEntityId;

  return (
    designatedLegalEntityId ?? business?.BusinessLegalEntity?.LegalEntityId ?? 0
  );
};
